<div class="skeleton-actions" [style.gap.px]="gap">
    @for (btn of actions; track $index) {
        <div
            class="skeleton-actions__btn skeleton"
            [style.width.px]="buttonWidth"
            [style.height.px]="buttonHeight"
        ></div>
    }
</div>
